import { render, staticRenderFns } from "./CardCompras.vue?vue&type=template&id=1e366600&scoped=true&"
import script from "./CardCompras.vue?vue&type=script&lang=js&"
export * from "./CardCompras.vue?vue&type=script&lang=js&"
import style0 from "./CardCompras.vue?vue&type=style&index=0&id=1e366600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e366600",
  null
  
)

export default component.exports